import styled from "styled-components"

import { SPACING } from "../../../../../component-library/design/spacing/spacing.constants"
import { TextField } from "../../../../../component-library/components/text-field/text-field.component"
import { PhoneNumberAutocomplete } from './phone-number-autocomplete.component'
import { NameAutocompleteV2 } from './name-autocomplete-v2.component'

const StyledAddressWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${SPACING.S};

  :last-of-type {
    margin-bottom: 0;
  }
  gap: ${SPACING.S};
  > .MuiAutocomplete-root {
    margin-right: 0;
  }
`

const StyledGenericAddressField = styled((props) => {
  const { gridRatio, ...rest } = props
  return <TextField {...rest} />
})`
  width: ${(props) => `calc(${props.gridRatio} * 100% - ${SPACING.S})`};

  :last-child {
    width: ${(props) => `calc(${props.gridRatio} * 100%)`};
  }
  & input { width: 100%; }
`
const StyledNameAutocompleteV2 = styled(NameAutocompleteV2)`
  flex: 1 1 50%;
`
const StyledPhoneNumberAutocomplete = styled(PhoneNumberAutocomplete)`
  flex: 1 1 50%;
`

export { StyledAddressWrapper, StyledGenericAddressField, StyledNameAutocompleteV2, StyledPhoneNumberAutocomplete }
